import { useEffect, useMemo, useState } from 'react';
import { Column } from '../../../components/table/types';

export const useConfigurableColumns: ({ columns }: { columns: Column[] }) => {
    columnVisibility: { [p: string]: boolean };
    displayedColumns: Column[];
    setColumnVisibility: (
        value:
            | ((prevState: { [p: string]: boolean }) => { [p: string]: boolean })
            | {
                  [p: string]: boolean;
              }
    ) => void;
} = ({ columns }: { columns: Column[] }) => {
    const [columnVisibility, setColumnVisibility] = useState<{ [key: string]: boolean }>(
        columns.reduce((acc, column: Column) => ({ ...acc, [column.id]: true }), {})
    );

    const columnIdsKey = useMemo(
        () =>
            columns
                .map((column) => String(column.id))
                .sort()
                .join('\0'),
        [columns]
    );

    useEffect(() => {
        setColumnVisibility((prev) => {
            const next = Object.fromEntries(columns.map((column) => [column.id, prev[column.id] ?? true]));
            const prevKeyStr = Object.keys(prev).sort().join('\0');
            const nextKeyStr = Object.keys(next).sort().join('\0');

            if (prevKeyStr !== nextKeyStr) {
                return next;
            }

            return prev;
        });
    }, [columnIdsKey]);

    const displayedColumns = useMemo(
        () => columns.filter((column) => columnVisibility[column.id]),
        [columns, columnVisibility]
    );

    return {
        columnVisibility,
        setColumnVisibility,
        displayedColumns,
    };
};
